// extracted by mini-css-extract-plugin
module.exports = {"root":"ToolsPanelTabs_root___MBDd","tabs":"ToolsPanelTabs_tabs__mT3GH","toolbar":"ToolsPanelTabs_toolbar__20V-Y"};